'use strict';
// Chuyển số giây thành mốc thời gian SRT chuẩn HH:MM:SS,mmm (giây luôn đủ 2 chữ số).
var pad = function(value, size) { return String(value).padStart(size || 2, '0'); };

var secondsToSrtTime = function(value) {
    var seconds = Number(value);
    if (!isFinite(seconds) || seconds < 0) seconds = 0;
    var totalMs = Math.round(seconds * 1000);
    var milliseconds = totalMs % 1000;
    var totalSeconds = Math.floor(totalMs / 1000);
    return pad(Math.floor(totalSeconds / 3600)) + ':' + pad(Math.floor(totalSeconds / 60) % 60) + ':' + pad(totalSeconds % 60) + ',' + pad(milliseconds, 3);
};

module.exports = { secondsToSrtTime: secondsToSrtTime };




//////////////////
// WEBPACK FOOTER
// ../shared/utils/subtitleTime.js
// module id = TkyB
// module chunks = 31